module.exports = __webpack_public_path__ + "static/media/ladyoflourdes.0ceecb1e.jpg";